import React, { useState } from "react";
import { useProposalContext } from "../..";
import styles from "./styles";
import moment from "moment";
import MilestoneBudgetList from "./MilestoneBudgetList";
import PaymentMilestoneList from "./PaymentMilestoneList";
import {
  Box,
  Button,
  CircularProgress,
  Divider,
  Stack,
  styled,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import { getApiData } from "../../../../utils/APIHelper";
import { toast } from "react-toastify";
import { formattedAmountWithoutAed } from "../../../../utils/CommonFunction";
import { ReactComponent as NewDesignIcon } from "../../../../assets/svg/NewDesignIcon.svg";
import { renderCurrencyIcon } from "../../../../utils/CurrencyUtils";
import Permission from "../../../../components/Permission";

const StyledButton = styled(Button)(({ theme }) => ({
  background: "#4D6BF6",
  color: "#ffffff",
  boxShadow: "none",
  border: "1px solid #4D6BF6",
  whiteSpace: "nowrap",
  fontSize: "16px",
  fontWeight: "500",
  borderRadius: "10px",
  padding: ".5vh 1vw",
  letterSpacing: "0",
}));

const GreyStyledButton = styled(Button)(({ theme }) => ({
  background: "#fff",
  color: "#0D0D0E",
  boxShadow: "none",
  border: "1px solid #D7D8D9",
  whiteSpace: "nowrap",
  fontSize: "16px",
  fontWeight: "500",
  borderRadius: "10px",
  padding: ".5vh 1vw",
  letterSpacing: "0",
}));

function Review() {
  const { proposalDetails } = useProposalContext();
  const navigate = useNavigate();

  const [buttonLoader, setButtonLoader] = useState(false);

  const handlePrevious = () => {
    navigate(
      `/new-create-proposal/${proposalDetails?.proposal_id}/payment-group`
    );
  };

  const handleModalClose = () => {
    navigate("/proposals");
  };
  console.log("proposalDetails", proposalDetails);

  async function handleSubmit() {
    setButtonLoader(true);
    const data = {
      status: "awaiting-approval",
    };
    try {
      const response = await getApiData(
        `api/project/update-status/${proposalDetails?.id}`,
        "PUT",
        data
      );
      setButtonLoader(false);
      if (response.success) {
        toast.success(response.message || "Proposal submitted successfully");
        navigate("/proposals");
      } else {
        toast.error(response.message || "Something went wrong. Try later");
      }
    } catch (error) {
      console.log("err===>", error);
    }
  }

  return (
    <>
      <div style={{ ...styles.container, ...styles.columnFlex, gap: "20px" }}>
        <h3 style={styles.heading}>Review</h3>
        <div style={{ display: "flex" }}>
          <div style={{ ...styles.rowFlex, gap: "15px", flex: "2" }}>
            <Box
              component="img"
              src={
                proposalDetails?.project_image?.[0]?.image
                  ? proposalDetails?.project_image?.[0]?.image
                  : proposalDetails?.default_image?.[0]?.image
              }
              alt="Project Icon"
              sx={{
                width: 80,
                height: 80,
                borderRadius: "16px",
                marginRight: 1,
              }}
            />
            <div style={styles.columnFlex}>
              <div style={{ ...styles.rowFlex, gap: "15px" }}>
                <p style={{ ...styles.idLabel, ...styles.rowFlex, gap: "5px" }}>
                  <NewDesignIcon /> {proposalDetails?.project_type}
                </p>
              </div>
              <h2 style={styles.projectHeading}>{proposalDetails?.name}</h2>
            </div>
          </div>

          <div style={{ ...styles.columnFlex, flex: "1" }}>
            <p style={styles.idLabel}>Cost</p>
            <p style={styles.price}>
              <div
                style={{
                  ...styles.small_sub_heading,
                  ...styles.rowFlex,
                  gap: "5px",
                }}
              >
                {renderCurrencyIcon('black-small')}
                {formattedAmountWithoutAed(proposalDetails?.budget)}
              </div>
            </p>
          </div>

          <div style={{ ...styles.columnFlex, flex: "1" }}>
            <p style={styles.idLabel}>Customer</p>
            <p style={styles.price}>
              {" "}
              <Box display="flex" alignItems="center">
                {proposalDetails?.user_data && (
                  <Box
                    component="img"
                    src={
                      proposalDetails?.user_data?.profile_url ||
                      "https://renohome.blob.core.windows.net/reno-cms/e56d3d53-e335-425f-990e-16e6b2bbee1b"
                    }
                    alt="Project Icon"
                    sx={{
                      width: 30,
                      height: 30,
                      borderRadius: "50%",
                      boxShadow: "0px 4px 2.67px 0px #00000026",
                      marginRight: 1,
                    }}
                  />
                )}
                {proposalDetails?.user_data?.username}
              </Box>
            </p>
          </div>
        </div>

        <div style={styles.columnFlex}>
          <h3 style={styles.text}>Proposal Summary</h3>
          <div style={styles.sub_heading}>{proposalDetails?.description}</div>
        </div>

        <div style={styles.columnFlex}>
          <h3 style={styles.text}>Scope of Work</h3>
          <div style={styles.sub_heading}>{proposalDetails?.scope_of_work}</div>
        </div>

        <div style={{ ...styles.rowFlex, justifyContent: "space-between" }}>
          <div style={{ ...styles.columnFlex, flex: 1, gap: "5px" }}>
            <h3 style={styles.text}>Location:</h3>
            <div style={styles.sub_heading}>
              {proposalDetails?.location || "-"}
            </div>
          </div>
          <div style={{ ...styles.columnFlex, flex: 1, gap: "5px" }}>
            <h3 style={styles.text}>Client Type:</h3>
            <div style={styles.sub_heading}>
              {proposalDetails?.client_type || "-"}
            </div>
          </div>
          <div style={{ ...styles.columnFlex, flex: 1, gap: "5px" }}>
            <h3 style={styles.text}>Scope:</h3>
            <div style={styles.sub_heading}>
              {proposalDetails?.scope || "-"}
            </div>
          </div>
        </div>

        <div style={{ ...styles.rowFlex, justifyContent: "space-between" }}>
          <div style={{ ...styles.columnFlex, flex: 1, gap: "5px" }}>
            <h3 style={styles.text}>Unit Type:</h3>
            <div style={styles.sub_heading}>
              {proposalDetails?.unit_type || "-"}
            </div>
          </div>
          <div style={{ ...styles.columnFlex, flex: 1, gap: "5px" }}>
            <h3 style={styles.text}>Unit:</h3>
            <div style={styles.sub_heading}>{proposalDetails?.unit || "-"}</div>
          </div>
          <div style={{ ...styles.columnFlex, flex: 1, gap: "5px" }}>
            <h3 style={styles.text}>Unit Size:</h3>
            <div style={styles.sub_heading}>
              {proposalDetails?.unit_size || "-"}
            </div>
          </div>
        </div>

        <div style={{ ...styles.rowFlex, justifyContent: "space-between" }}>
          <div style={{ ...styles.rowFlex, flex: 1, gap: "5px" }}>
            <h3 style={styles.text}>Start:</h3>
            <div style={styles.sub_heading}>
              {proposalDetails?.start_date
                ? moment(proposalDetails?.start_date).format("MMM DD, YYYY")
                : "-"}
            </div>
          </div>{" "}
          <div
            style={{
              ...styles.rowFlex,
              flex: 1,
              gap: "5px",
              justifyContent: "flex-end",
            }}
          >
            <h3 style={styles.text}>End:</h3>
            <div style={styles.sub_heading}>
              {proposalDetails?.end_date
                ? moment(proposalDetails?.end_date).format("MMM DD, YYYY")
                : "-"}
            </div>
          </div>
        </div>
        <MilestoneBudgetList proposalDetails={proposalDetails} />
        <PaymentMilestoneList proposalDetails={proposalDetails} />

        <Divider sx={{ width: "100%" }} />
        <Stack
          direction="row"
          justifyContent="space-between"
          alignItems="center"
        >
          <GreyStyledButton onClick={handlePrevious}>
            {buttonLoader ? (
              <CircularProgress size={26} style={{ color: "#fff" }} />
            ) : (
              "Previous Step"
            )}
          </GreyStyledButton>

          <Stack
            alignItems="end"
            flexDirection="row"
            justifyContent="flex-end"
            gap="10px"
          >
            <GreyStyledButton onClick={handleModalClose}>
              Close
            </GreyStyledButton>
            <Permission resource="PROJECTS" action="CREATE">
              <StyledButton variant="contained" onClick={handleSubmit}>
                {buttonLoader ? (
                  <CircularProgress size={26} style={{ color: "#fff" }} />
                ) : (
                  "Submit"
                )}
              </StyledButton>
            </Permission>{" "}
          </Stack>
        </Stack>
      </div>
    </>
  );
}
export default Review;
